import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'

interface IProps {
  cancelPolicy: string
  onClose: () => void
}

const RefundInfoModal: React.FC<IProps> = ({ cancelPolicy, onClose }) => {
  return (
    <Modal>
      <div className="Refund_Modal_Container">
        <button
          className="Refund_Modal_Close"
          onClick={onClose}
          type="button"
          aria-label="Close This Window"
        >
          <SvgIcon name="close" className="icon" ariaHidden={true} />
        </button>
        <p className="Refund_Modal_Title">Cancellation policy</p>
        <div className="Refund_Modal_Content">{cancelPolicy}</div>
      </div>
    </Modal>
  )
}

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${constants.COLORS.blackOverray};
  z-index: 6000;

  .Refund_Modal_Container {
    position: relative;
    font-size: 1.4rem;
    width: 72rem;
    padding: 4rem 2.4rem;
    box-shadow: ${constants.COLORS.cardShadow};
    border-radius: 1.6rem;
    background-color: ${constants.COLORS.white};
    color: ${constants.COLORS.black};
    max-width: calc(100% - 3.2rem);
    margin: 0 auto;
  }

  .Refund_Modal_Close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.2rem;
    height: 3.2rem;
    border: 1px solid ${constants.COLORS.divider2};
    border-radius: 50%;
    position: absolute;
    right: 2.4rem;
    top: 2.4rem;
    background-color: ${constants.COLORS.white};
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s, color 0.2s;
    z-index: 999;
    @media screen and (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      right: 1.6rem;
      top: 1.6rem;
    }
    svg {
      width: 2rem;
    }
    &:hover {
      color: ${constants.COLORS.white};
      background-color: ${constants.COLORS.primary};
      border-color: ${constants.COLORS.primary};
    }
  }

  .Refund_Modal_Title {
    font-weight: bold;
    text-align: center;
    font-size: 2rem;
    margin-bottom: 3.2rem;
    position: relative;
  }

  .Refund_Modal_Content {
    white-space: pre-wrap;
    font-size: 14px;
    color: ${constants.COLORS.black};
    line-height: 20px;
    p {
      margin: 0 0 17px;
    }
    ul {
      padding: 0;
      margin: 0 0 20px;
      list-style: none;
    }
  }
`

export default RefundInfoModal
